import React, {forwardRef, useImperativeHandle, useRef, useState} from "react";
import { Select, MenuItem, InputLabel } from "@material-ui/core/";

const Selector = forwardRef((props, ref) => {
  const inputRef = useRef();
  const isDataGrid = props.isdatagrid || false;
  const [originalValue, setOriginalValue] = useState(props.value);
  const [controlValue, setControlValue] = useState(props.value);

  if (originalValue !== props.value) {
    setOriginalValue(props.value);
    setControlValue(props.value);
  }

  const onChangeHandler = (event) => {
    if (props.onChange) {
      props.onChange(event.target.value);
    }
    setControlValue(event.target.value);
  }

  useImperativeHandle(ref, () => {
    const value = controlValue === undefined ? {} : controlValue;

    return {
      // the final value to send to the grid, on completion of editing
      getValue() {
        return value;
      },
      // Gets called once before editing starts, to give editor a chance to
      // cancel the editing before it even starts.
      isCancelBeforeStart() {
        return false;
      },

      // Gets called once when editing is finished (eg if enter is pressed).
      // If you return true, then the result of the edit will be ignored.
      isCancelAfterEnd() {
        return false;
      },

      afterGuiAttached () {
        inputRef.current.focus();
      }
    }
  });

  // console.log(props.lookupValues, props.title, props.label, controlValue, originalValue);
  return (
    <div style={{ display: "inline"}}>
      {props.label === undefined
        ? <div></div>
        : <InputLabel shrink>{props.label}</InputLabel>}
      <Select
        className={isDataGrid?"dataGridSelector onDataGrid":undefined}
        ref={inputRef}
        inputProps={props.inputProps}
        title={props.title === undefined ? "" : props.title}
        value={controlValue === undefined ? "" : controlValue}
        onChange={onChangeHandler}
        style={{
          fontSize: 13,
        }}
        SelectDisplayProps={{ "aria-label": props.title === undefined ? "" : props.title }}
      >
        {props.lookupValues?Object.entries(props.lookupValues).map(([key, value]) => (
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        )):<MenuItem key="" value="">...</MenuItem>}
      </Select>
    </div>
  );
})

export default Selector;
